<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "./common/font/font.css";
/* flex */
.flex {
  display: flex;
}
.fl-1 {
  flex: 1;
}
.fl-4 {
  flex: 4;
}
.fl-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fl-col {
  display: flex;
  flex-direction: column;
}
.fl-row {
  display: flex;
  flex-direction: row;
}
.fl-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fl-col-end {
  display: flex;
  align-items: flex-end;
}
.fl-row-center {
  display: flex;
  justify-content: center;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
}
.fl-bet {
  display: flex;
  justify-content: space-between;
}
.fl-around {
  display: flex;
  justify-content: space-around;
}
/* 内边距 */
.pd-20 {
  padding: 20rpx;
}
.pd-33 {
  padding: 33rpx;
}
.pd-24 {
  padding: 24rpx;
}
.pd-50 {
  padding: 50rpx;
}
.pd-88 {
  padding: 88rpx;
}
.pd-row-24 {
  padding: 0 24rpx;
}
.pdr-19 {
  padding-right: 19rpx;
}

/* 外边距 */
.mgr-10 {
  margin-right: 10rpx;
}
.mgr-16 {
  margin-right: 16rpx;
}
.mgr-24 {
  margin-right: 24rpx;
}
.mgr-26 {
  margin-right: 26rpx;
}
.mgrl-13 {
  margin-right: 13px;
  margin-left: 13px;
}
.mgr-30 {
  margin-right: 30rpx;
}
.mgt-10 {
  margin-top: 10rpx;
}
.mgt-20 {
  margin-top: 20rpx;
}
.mgb-10 {
  margin-bottom: 10rpx;
}
.mgb-20 {
  margin-bottom: 20rpx;
}
.mgh-40 {
  margin: 40rpx 0;
}
/* 边框 */
.bor {
  border: 1rpx solid;
}
.line-20 {
  width: 100%;
  height: 20rpx;
  background: #f5f5f5;
}
/* 划线 */
.line-th {
  text-decoration: line-through;
}
/* 实心虚线 */
.bor-dot {
  border: 1rpx dotted;
}
/* 长条虚线 */
.bor-dash {
  border: 1rpx dashed;
}
.rad-40 {
  border-radius: 40rpx;
}
.row_1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.row_2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
